/**
 * Analytics event labels for Enterprise platform landing pages (`/enterprise/overview/skills`, `/enterprise/overview/cohorts`, `/enterprise/overview/human-ai-support`).
 * Skills labels must remain stable for `slug === 'skills'`.
 */
export type EnterpriseLandingAnalyticsLabels = {
  benefitsVideo: string;
  challengeVideo: string;
  demoCta: string;
  footerContact: string;
  intelligenceTab: string;
  watchOverviewVideo: string;
};

const SKILLS_LABELS: EnterpriseLandingAnalyticsLabels = {
  benefitsVideo: 'benefits_video_clicked',
  challengeVideo: 'watch_skills_challenge_video_clicked',
  demoCta: 'demo_skills_clicked',
  footerContact: 'contact_us_clicked',
  intelligenceTab: 'skills_intelligence_tab_clicked',
  watchOverviewVideo: 'watch_skills_overview_clicked',
};

const COHORTS_LABELS: EnterpriseLandingAnalyticsLabels = {
  benefitsVideo: 'benefits_cohorts_video_clicked',
  challengeVideo: 'watch_cohorts_challenge_video_clicked',
  demoCta: 'demo_cohorts_clicked',
  footerContact: 'contact_us_cohorts_clicked',
  intelligenceTab: 'cohorts_landing_tab_clicked',
  watchOverviewVideo: 'watch_cohorts_overview_clicked',
};

const HUMAN_AI_SUPPORT_LABELS: EnterpriseLandingAnalyticsLabels = {
  benefitsVideo: 'benefits_human_ai_video_clicked',
  challengeVideo: 'watch_human_ai_challenge_video_clicked',
  demoCta: 'demo_human_ai_clicked',
  footerContact: 'contact_us_human_ai_clicked',
  intelligenceTab: 'human_ai_landing_tab_clicked',
  watchOverviewVideo: 'watch_human_ai_overview_clicked',
};

const PROJECT_BASED_LEARNING_LABELS: EnterpriseLandingAnalyticsLabels = {
  benefitsVideo: 'benefits_project_based_video_clicked',
  challengeVideo: 'watch_project_based_challenge_video_clicked',
  demoCta: 'demo_project_based_clicked',
  footerContact: 'contact_us_project_based_clicked',
  intelligenceTab: 'project_based_landing_tab_clicked',
  watchOverviewVideo: 'watch_project_based_overview_clicked',
};

export function getEnterpriseLandingAnalyticsLabels(slug: string): EnterpriseLandingAnalyticsLabels {
  if (slug === 'cohorts') {
    return COHORTS_LABELS;
  }
  if (slug === 'human-ai-support') {
    return HUMAN_AI_SUPPORT_LABELS;
  }
  if (slug === 'project-based-learning') {
    return PROJECT_BASED_LEARNING_LABELS;
  }
  return SKILLS_LABELS;
}
